export default "__VITE_ASSET__CrRmTGfE__"